
interface AnimationQueueItem {
    startAnimation: () => void
}
export class UIMGamePlayerCardsAnimationQueueController {
    private readonly animationQueue: AnimationQueueItem[] = []
    private animationActive: boolean = false

    addAnimationToQueue(startAnimation: () => void) {
        this.animationQueue.push({
            startAnimation: startAnimation,
        })
        this.animate()
    }

    animate() {
        if(this.animationActive == true) return
        if(this.animationQueue.length == 0) return
        this.animationActive = true
        this.animationQueue[0].startAnimation()
    }

    currentAnimationIsFinished() {
        this.animationActive = false
        this.animationQueue.shift()
        setTimeout(() => this.animate(), 100)
    }
}
